import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新内容
            </h2>
            <p className="text-sm text-foreground-500 mt-1">持续更新中的新鲜内容</p>
          </div>
          <Link
            to="/category/news"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            更多内容 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.cover_image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2">
                  {article.category}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1.5">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                  {article.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                  <span>{article.read_time}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}